export const redirectTo = (path: string) => {
  window.location.href = path;
};
